<abi-back-button class="d-print-none"></abi-back-button>
<button class="ml-1 mb-2" abiPrint>{{ 'System.Print' | translate }}</button>
<abi-spinner *ngIf="loading"></abi-spinner>
<div class="container-fluid px-0 d-print-block printz" [class.d-none]="!useRouting" *ngIf="!loading">
  <h2 class="text-center border-top border-bottom border-secondary">{{ header }}</h2>
  <div class="row mt-3">
    <div class="col-4">
      <dl class="row px-0">
        <dt class="col-4">From</dt>
        <dd class="col-8 pre-wrap">{{ asTextBlock() }}</dd>
        <ng-template [ngIf]="registrationNumber">
          <dt class="col-4">Reg No.</dt>
          <dd class="col-8">{{ registrationNumber }}</dd>
        </ng-template>
        <ng-template [ngIf]="vatNumber">
          <dt class="col-4">Vat No.</dt>
          <dd class="col-8">{{ vatNumber }}</dd>
        </ng-template>
      </dl>
    </div>
    <div class="col-6">
      <dl class="row px-0">
        <dt class="col-4">Receipt Number</dt>
        <dd class="col-8">{{ receipt }}</dd>
        <dt class="col-4">Payment Date</dt>
        <dd class="col-8">{{ receiptDate }}</dd>
        <dt class="col-4">Job ID</dt>
        <dd class="col-8">{{ job?.jobId }}</dd>

        <dt class="col-4">Telephone</dt>
        <dd class="col-8">{{ telephone }}</dd>
        <dt class="col-4">Email</dt>
        <dd class="col-8">{{ email }}</dd>
        <dt class="col-4">&nbsp;</dt>
        <dd class="col">
          <a [href]="websiteUrl">{{ websiteUrl }}</a>
        </dd>
      </dl>
    </div>
    <div class="col-2">
      <img [src]="'assets/logos-big/' + tenant + '.svg?v=1'" class="w-100" [alt]="tenant" />
    </div>

  </div>

  <div class="row border-top border-secondary pt-3">
    <div class="col-4">
      <dl class="row px-0">
        <dt class="col-4">To</dt>
        <dd class="col-8">{{ job?.contact | contact }}</dd>
        <dt class="col-4">Address</dt>
        <dd class="col-8 pre-wrap">{{ job?.address | address }}</dd>
        <dt class="col-4">Cellphone</dt>
        <dd class="col-8">{{ job?.contact.mobile }}</dd>
        <dt class="col-4">Vat No.</dt>
        <dd class="col-8">{{ job?.contact.instantMessageId }}</dd>
      </dl>
    </div>
    <div class="col-4">
      <dl class="row px-0">
        <dt class="col-4">Model</dt>
        <dd class="col-8 ">{{ job?.machine.modelId }}</dd>
        <dt class="col-4">Name</dt>
        <dd class="col-8 ">{{ job?.machine.name }}</dd>

      </dl>
    </div>
    <div class="col-4">
        <ng-container *ngIf="hasDealerInfo()">
            <ng-container *hasTranslation="'Receipt.Dealer'">
                <dl class="row px-0">
                    <dt class="col-4" translate="Machine.BranchID"></dt>
                    <dd class="col-8" [abiLookupdisplay]="job?.machine?.dealerBranchId" listName="DealerBranch"></dd>

                    <dt class="col-4" translate="Contact.Name"></dt>
                    <dd class="col-8">{{ job?.dealerContact | contact }}</dd>

                    <dt class="col-4" translate="Contact.OfficeHours"></dt>
                    <dd class="col-8">{{ job?.dealerContact?.officeHours }}</dd>

                    <dt class="col-4" translate="Contact.Email"></dt>
                    <dd class="col-8">{{ job?.dealerContact?.emailAddress }}</dd>

                    <dt class="col-4" translate="Contact.InstantMessageID"></dt><!-- todo: REWORK THIS -->
                    <dd class="col-8" [abiLookupdisplay]="job?.machine?.dealerBranchId" listName="DealerBranch" display="custom" customProperty="instantMessageId"></dd>
                </dl>
            </ng-container>
        </ng-container>
    </div>

  </div>

  <div class="border-top">
    <!--h4 class="text-center border rounded border-secondary">Items</h4-->
    <table class="table">
      <thead>
        <tr>
          <th>
            Type
          </th>
          <th>
            Item ID
          </th>
          <th>
            Description
          </th>
          <th class="text-right">
            Quantity
          </th>
          <th class="text-right">
            Price
          </th>
          <th class="text-right">
            Amount
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let line of lines">
          <td [abiLookupdisplay]="line.typeId" listName="CodeJobLineType">
          </td>
          <td>
            {{ line.itemId }}
          </td>
          <td>
            {{ line.line1 }}
          </td>
          <td class="text-right">
            {{ line.quantityOrdered }}
          </td>
          <td class="text-right">
            {{ line.price|number:'1.2-2' }}
          </td>
          <td class="text-right">
            {{ line.paid|number:'1.2-2' }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr *ngIf="showVat">
          <td colspan="3">
          </td>
          <td class="text-right">
            VAT
          </td>
          <td></td>
          <td class="text-right">{{ vat|number:'1.2-2' }}</td>
        </tr>
        <tr>
          <td colspan="4" class="text-right">
            Total
          </td>
          <td colspan="2" class="text-right">{{ total|number:'1.2-2' }}</td>
        </tr>
      </tfoot>
    </table>

  </div>
</div>
